<template>
  <v-container>
    <v-layout>
      <v-flex>
        <v-text-field
          v-model="searchValue"
          label="搜尋"
          :color="Theme.GREEN"
          placeholder="查詢"
        ></v-text-field>
      </v-flex>
      <v-flex>
        <v-btn
          class="mr-2"
          :color="Theme.GREEN"
          dark
          @click.prevent="searchEvent"
          >搜尋</v-btn
        >
        <v-btn :color="Theme.YELLOW" dark @click.prevent="reset">重置</v-btn>
      </v-flex>
      <v-flex>
        <div class="file">
          <span v-if="!files">選擇圖片</span>
          <input
            v-if="!files"
            ref="files"
            type="file"
            multiple
            :name="uploadFieldName"
            @change="handleFilesUpload()"
            accept="image/*"
            class="input-file"
          />
          <span v-else>已選擇圖片</span>
        </div>
        <v-btn depressed dark color="#0BA7A3" @click="upload">上傳</v-btn>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" max-width="500px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title>
            <span class="title">編輯</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap column>
                <v-flex
                  xs12
                  sm6
                  md4
                  v-for="col in columnKeys.filter(
                    (item) => item.value !== 'action'
                  )"
                  :key="col.value"
                >
                  <v-layout row wrap v-if="col.value === 'createDate'">
                    <span
                      >建立時間：
                      {{ formatTime(editedItem[col.value]) }}
                    </span>
                  </v-layout>
                  <v-select
                    v-else-if="col.options"
                    :color="Theme.GREEN"
                    :items="col.options"
                    :label="col.text"
                    item-text="text"
                    item-value="key"
                    v-model="editedItem[col.value]"
                  />
                  <v-text-field
                    v-else
                    v-model="editedItem[col.value]"
                    :color="Theme.ORANGE"
                    :label="col.text"
                    :rules="col.rules"
                    :disabled="col.disabled"
                    :required="col.required"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :color="Theme.ORANGE" dark @click="dialog = false"
              >取消</v-btn
            >
            <v-btn
              :color="Theme.GREEN"
              dark
              @click="save"
              :loading="loading"
              :disabled="loading"
              >儲存</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <table-view
      :items="list"
      :columnKeys="columnKeys"
      :pagination="pagination"
      :loading="loading"
      @changePage="changePage"
      @cellEvent="cellEvent"
    />

    <v-snackbar
      v-model="snackBar"
      :right="true"
      :timeout="3000"
      :top="true"
      :vertical="false"
    >
      {{ snackText }}
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TableView from "@/components/TableView";
import common from "@/mixins/common";
export default {
  name: "files",
  components: { TableView },
  mixins: [common],
  data() {
    return {
      searchValue: "",
      snackBar: false,
      snackText: "",
      files: "",
      uploadedFiles: [],
      uploadFieldName: "photos",
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalItems: 0,
      },
      loading: false,
      valid: true,
      dialog: false,
      editedItem: {},
      list: [],
    };
  },
  created() {
    this.loadData();
  },
  computed: {
    ...mapGetters(["getFileList", "getUserInfo"]),
    columnKeys() {
      return [
        {
          value: "action",
          text: "編輯",
          isEvent: true,
          color: this.Theme.GREEN,
          sortable: false,
        },
        {
          value: "fileId",
          text: "檔案編號",
          sortable: false,
          required: true,
          disabled: true,
          rules: [
            (v) => !!v || "請輸入商品編號！",
            (v) => (v && v.length >= 8) || "商品編號至少需要8個字元",
          ],
        },
        {
          value: "name",
          text: "檔案名稱",
          sortable: false,
          required: true,
          disabled: true,
        },
        {
          value: "path",
          text: "網址",
          sortable: false,
          required: true,
          disabled: true,
          isImage: true,
        },
        {
          value: "imageType",
          text: "圖片類型",
          options: this.getImageType,
          disabled: false,
        },
        {
          value: "category",
          text: "類別",
          sortable: true,
          disabled: false,
          rules: [(v) => !!v || "請輸入類別！"],
        },
        {
          value: "createDate",
          text: "建立時間",
          sortable: true,
          disabled: true,
          width: 170,
        },
        {
          value: "copy",
          text: "複製網址",
          sortable: false,
          disabled: true,
          width: 170,
          color: "#0ba7a3",
          isEvent: true,
        },
        {
          value: "delete",
          text: "刪除",
          sortable: false,
          disabled: true,
          width: 170,
          isEvent: true,
        },
      ];
    },
  },
  methods: {
    ...mapActions(["fetchFileList", "saveFileInfo", "uploadFileList"]),
    searchEvent() {
      if (!this.searchValue) return;
      this.list = this.getFileList.filter(
        (item) => item.category.indexOf(this.searchValue) > -1
      );
    },
    reset() {
      this.searchValue = "";
      this.loadData();
    },
    loadData() {
      this.fetchFileList().then(() => {
        this.list = this.getFileList;
        this.pagination.totalItems = this.getFileList.length;
      });
    },
    /**
     * 頁面切換
     * @param page Object - { page: 頁數, itemsPerPage: 每頁幾筆 }
     * */
    changePage(page) {
      this.pagination.page = page.page;
      this.pagination.itemsPerPage = page.itemsPerPage;
      console.log(`changePage ${JSON.stringify(this.pagination)}`);
      this.loadData();
    },
    /**
     * 列表按鈕點擊事件
     * @param cell Object - { key: 事件代碼, item: 物件 }
     * */
    cellEvent(cell) {
      console.log(`cellEvent == ${JSON.stringify(cell)}`);
      if (cell.key === "delete") {
        this.deleteFile(cell.item);
      } else if (cell.key === "copy") {
        const url = this.formatURL(cell.item.path);
        this.copyURL(url);
      } else {
        this.showEditView(cell.item);
      }
    },
    formatURL(path) {
      const newPath = path.replace("public/", "");
      const url = `https://innovision.com.tw/${newPath}`;
      return url;
    },
    handleFilesUpload() {
      this.files = this.$refs.files.files;
      console.log("handleFilesUpload");
    },
    upload() {
      const formData = new FormData();
      for (let i = 0; i < this.files.length; i += 1) {
        const file = this.files[i];
        formData.append(`photos[${i}]`, file);
        // formData.append(`photos`, file);
      }
      // this.files.forEach((file, i) => {
      //   formData.append(`files[${i}]`, file);
      // });
      // for( var i = 0; i < this.files.length; i++ ){
      //     let file = this.files[i];
      //     formData.append('files[' + i + ']', file);
      // }

      this.uploadFileList({ fileList: formData }).then((response) => {
        console.log(`upload ... ${JSON.stringify(response)}`);
        if (response.status === 200) {
          console.log("上傳成功");
          this.snackText = "檔案上傳成功！";
          this.snackBar = true;
          this.fetchFileList();
          this.files = "";
        }
        this.loadData();
      });
    },
    formatCategory(category) {
      if (category === "normal") {
        return "無分類";
      }
      return category;
    },
    copyURL(url) {
      const input = document.createElement("input");
      input.setAttribute("value", url);
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      this.snackText = "已複製網址！";
      this.snackBar = true;
    },
    showEditView(item) {
      this.editedItem = item;
      this.dialog = true;
    },
    save() {
      this.loading = true;
      const params = {
        fileId: this.editedItem.fileId,
        category: this.editedItem.category,
        imageType: this.editedItem.imageType,
        isDelete: this.editedItem.isDelete,
      };
      this.saveFileInfo(params).then(
        () => {
          this.loading = false;
          this.snackText = "儲存成功！";
          this.snackBar = true;
          this.dialog = false;
          if (this.editedItem.isDelete === 1) {
            this.loadData();
          }
        },
        (error) => {
          this.snackText = `發生錯誤 ${JSON.stringify(error)}`;
          this.snackBar = true;
          this.loading = false;
        }
      );
    },
    deleteFile(item) {
      this.editedItem = item;
      this.editedItem.isDelete = 1;
      this.save();
    },
    formatTime(date) {
      return this.formatDateTime(date);
    },
  },
};
</script>

<style scoped>
.file {
  width: 150px;
  height: 36px;
  padding: 5px 10px;
  background: #f29b87;
  border: 1px solid #f29b87;
  position: relative;
  color: #fff;
  border-radius: 2px;
  text-align: center;
  float: left;
  cursor: pointer;
  margin: 6px;
}
.input-file {
  position: absolute;
  z-index: 1000;
  opacity: 0;
  cursor: pointer;
  right: 0;
  top: 0;
  height: 100%;
  font-size: 24px;
  width: 100%;
}
</style>
